import { Dialog, DialogClose, DialogContent, DialogDescription, DialogTitle, DialogTrigger } from "./Dialog";
import { Button } from "./Button";
import { Loader2 } from "lucide-react";
import cn from "clsx"
import { formatDate } from "../utils/formatDate";
import { useState, useEffect } from "react";
import { useSubscription } from "../hooks/useSubscription";
import { Charge } from "@rechargeapps/storefront-client";
import { useGlobal } from "../context/globalProvider";
import { useCharge } from "../hooks/useCharge";

const OnetimeAddDialog = ({ 
  product,
  nextOrder,
  Trigger,
  source,
  props,
  submit,
  sale
}: { 
  product: any,
  Trigger: React.ReactNode,
  source: string,
  nextOrder?: Charge,
  props?: any,
  submit?: () => Promise<void>,
  sale?: boolean
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { createOneTimeOrder, isLoading } = useSubscription();
  const [ isSubmitting, setIsSubmitting ] = useState(false);
  const { refreshData, orders, sendEvent } = useGlobal();
  const { addDiscount } = useCharge();

  useEffect(() => {
    if (isOpen && source?.includes('banner')) {
      sendEvent('onetime_dialog_opened', { source });
    }
  }, [isOpen, source]);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        {Trigger}
      </DialogTrigger>
      <DialogContent className="bg-white">
        <DialogTitle>Add One Time Purchase</DialogTitle>
        <DialogDescription>
          Adding this one-time purchase will add {product.title} to your {formatDate(nextOrder?.scheduled_at)} order.
        </DialogDescription>

        <div className="flex justify-end gap-2">
          <DialogClose asChild>
            <Button variant="outline">Cancel</Button>
          </DialogClose>
          <Button disabled={isLoading || isSubmitting} onClick={async () => {
            if (submit) {
              setIsSubmitting(true);
              await submit();
              await refreshData();
              setIsSubmitting(false);
              setIsOpen(false);
              return;
            }

            const productIsRoutineBuilder = false;
            await createOneTimeOrder({
              address_id: Number(nextOrder?.address_id),
              external_variant_id: {
                ecommerce: product?.first_variant?.id.toString(),
              },
              quantity: 1,
              next_charge_scheduled_at: nextOrder?.scheduled_at,
              product_title: product?.title,
              ...props,
            }, source, productIsRoutineBuilder ? {
              addDiscountCode: "BYESUMMER",
              chargeCodes: nextOrder?.discounts || []
            } : {})

            setIsOpen(false);
          }}>
            <span className={cn({ "opacity-0": isLoading || isSubmitting })}>Yes, add to my order</span>
            { (isSubmitting || isLoading) && <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"><Loader2 className="w-4 h-4 animate-spin" /></span> }
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default OnetimeAddDialog;